module.exports = __webpack_public_path__ + "4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/styles/patterns/4.png
// module id = 882
// module chunks = 11